/**
 * Product (PDP) layout when `document.body` has `page` + `page--product-page`
 * (CMS `pageType` `product` or page with `productId`, see
 * `contentful/utils/page-type-body-slug.js` and `components/contentful/page.jsx`).
 */

import {bazaarvoicePdpGlobalStyles} from '@amblique/king-living/app/theme/contentful/bazaarvoice-pdp-global';

export const productPageGlobalStyles = {
  'body.page--product-page': {
    ...bazaarvoicePdpGlobalStyles,
    '& .variations-section .chakra-stack:empty': {
      display: 'none',
    },
    '& .variations-section-content:not(:has(.product-tabs-container))': {
      marginTop: {base: '30px', lg: '32px'},
    },
    '& .variations-section-content:not(:has(.product-tabs-container)) .choose-your-layout-trigger-container': {
      marginTop: {base: '0', lg: '0'},
    },
    '& .variations-section-content:not(:has(.choose-your-layout-trigger-container)) .product-tabs-container + *': {
      borderTop: 'none',
    },
    '& .variations-section-content:not(:has(.choose-your-layout-trigger-container)) .product-tabs-container + .choose-your-sets-container': {
      marginTop: {base: '40px', lg: '40px'},
    },
    '& .variations-section-content:not(:has(.choose-your-layout-trigger-container)):not(:has(.optional-add-ons-container__root)):not(:has(.cover-swatch-grid)):not(:has(.choose-your-sets-container)):not(:has(.customize-steps-inline-content .customize-steps-content-body > *)) .pdp-delivery-availability': {
      borderTop: 'none',
      paddingTop: {base: '40px', lg: '40px'},
    },
    '& .product-action-section': {
      borderTop: '2px solid',
      borderColor: 'brandColors.greyscale10',
      paddingTop: {base: '56px', lg: '64px'},
    },
    '& .component--product-tiles > .chakra-stack,& .component--category-card-grid .contentful-category-card-grid__heading': {
      paddingBottom: {base: '24px', lg:'4px'}
    },
    '& .component--container:has(> .component--product-tiles):not(:has(> :not(.component--product-tiles)))': {
      paddingTop: {base: '48px', lg:'80px'}
    },
    '& .component--category-card-grid': {
      paddingTop: {base: '48px', lg:'80px'},
      paddingBottom: {base: '48px', lg:'120px'}
    },
    '& #app-main:has(.component--product-tiles)': {
      '& > .component--product-tiles': {
        paddingTop: {base: '48px', lg:'80px'}
      },
    },
    '& .component--product-tiles:has(+ .component--product-tiles), & .component--product-tiles:has(+ .component--category-card-grid), & .component--category-card-grid:has(+ .component--product-tiles), & .component--category-card-grid:has(+ .component--category-card-grid)': {
      paddingBottom: {base: '48px', lg:'100px'}
    },
    '& .component--product-tiles + .component--category-card-grid': {
      paddingTop: {base: '0', lg:'0'},
    },
    '& .component--split-heading:has(+ .component--media-carousel)': {
      paddingTop: {base: '64px', lg: '120px'},
      paddingBottom: {base: 'unset', lg: 'unset'},
      '&.split-heading--right-blank': {
        gap: {base: '16px', lg: '36px'},
      },
      '& + .component--media-carousel': {
        paddingTop: {base: '24px', lg: '64px'},
        paddingBottom: {base: '64px', lg: '120px'},
      },
    },
    '& .component--container:has(.component--media-carousel)': {
      '& .swiper-cf-022': {
        '& .swiper-slide': {
          maxWidth: {base: 'unset', lg: 'unset'},
        },
        '& .chakra-text': {
          fontSize: {base: '16px', lg: '24px'},
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '140%',
          color: {base: 'brandColors.greyscale90', lg: 'black'},  
        }
      },
    },
    '& .optional-add-ons-container__root': {
      borderTop: '2px solid',
      borderColor: 'brandColors.greyscale10',
    },
    '& .component--icon-set .icon__description': {
      // color: {base: 'whiteAlpha.800', lg: 'whiteAlpha.900'},
      fontFamily: 'body',
      fontSize: {base: '16px', lg: '18px'},
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: {base: '140%', lg: '120%'},
      textAlign: 'center',
    },
    '& .component-container__background': {
      '& .component--container:has( .component--hero-banner)': {
        '& .component--hero-banner': {
          paddingY: {base: '60px', lg: '120px'},
          paddingX: {base: '20px', lg: '120px'},
          '& .component--action-links:hover p, & .component--action-links:hover, & .component--action-links:hover a': {
            textDecoration: 'none',
          },
        },
      },
      '& .component--container:has( .component--split-heading)': {
        '& .component--split-heading:has(+ .component--teaser-tile-block)': {
          paddingTop: {base: '60px', md: '120px'},
          paddingBottom: {base: '40px', md: '64px'},
          '& .split-heading__left-region': {
            '& .split-heading__heading': {
              fontSize: {base: '28px', lg: '40px'},
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: 1.2,
              letterSpacing: {base: '-0.28px', lg: '-0.4px'},
              fontVariantNumeric: 'lining-nums proportional-nums',
            },
          },
          '& .split-heading__right-region': {
            '& .split-heading__description': {
              fontSize: {base: '16px', lg: '18px'},
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: 1.6,
            },
          },
        },
        '& .component--teaser-tile-block': {
          '& .chakra-text': {
            fontSize: {base: '14px', lg: '18px'},
            fontWeight: 400,
            lineHeight: {'base': '140%', 'lg': '120%'},
          },
        },
      },
    },
    '& .section-panel-split': {
      '& .component--action-links': {
        '& .chakra-link p': {
          fontSize: {base: '14px', lg: '16px'},
        }
      },
    },
    '& .configuration-gallery-wrapper img': {
      objectFit: 'cover',
    },
    '& .component--king-difference-media-cf013': {
      '& .king-difference-media-cf013__eyebrow': {
        fontSize: {base: '12px', lg: '12px'},
        color: {base: 'brandColors.charcoal', lg: 'brandColors.charcoal'},
        fontWeight: 600,
      },
      '& .king-difference-media-cf013__heading': {
        fontSize: {base: '32px', lg: '40px'},
        color: {base: 'brandColors.extraDarkCharcoal', lg: 'brandColors.extraDarkCharcoal'},
        fontWeight: 500,
      },
      '& .king-difference-media-cf013__description': {
        fontSize: {base: '14px', lg: '16px'},
        color: {base: 'brandColors.charcoal', lg: 'brandColors.charcoal'},
        fontWeight: 400,
      },
    },
    '& .component--award-block': {
      '& .charka-headding': {
        fontSize: {base: '32px', lg: '40px'},
      },
      '& .chakra-text': {
        fontSize: {base: '14px', lg: '16px'},
      }
    },
    '& .hero-content-wrapper': {
      '& .component--action-links .chakra-link': {
        paddingX: '48px',
        paddingY: '16px',
        '& p': {
          fontSize: {base: '14px', lg: '16px'},
          fontWeight: 600,
        }
      }
    },
    '& .swiper-cf-011-thumbs': {
      '& .swiper-slide': {
        '& .rich-text-content .chakra-text': {
          fontSize: {base: '20px', lg: '24px'},
          fontWeight: 500,
          lineHeight: {'base': '150%', 'lg': '140%'},
        }
      }
    },
    '& .contentful-category-card-grid__grid-item': {
      '& .contentful-card__swatch-more-label--desktop': {
        fontSize: {base: '12px', lg: '12px'},
      },
      '& .contentful-card__swatch-more-label--mobile': {
        fontSize: {base: '13px', lg: '13px'},
      },
      '& .contentful-card__content': {
        paddingX: {base: '0', lg: '8px'},
      },
      '& .contentful-card__content .chakra-link,& .contentful-card__content .chakra-link .chakra-text': {
        fontSize: {base: '16px', lg: '24px'},
      },
      '& .contentful-card__description': {
        fontSize: {base: '13px', lg: '16px'},
      },
    },
    '& .product-support-accordion-content': {
      '& p': {
        marginBottom: {base: '12px', lg: '12px'},
        fontSize: {base: '12px', lg: '16px'},
        fontWeight: 400,
        lineHeight: {'base': '120%', 'lg': '120%'},
      },
      '& a': {
        fontSize: {base: '14px', lg: '16px'},
        fontWeight: 600,
        lineHeight: {'base': '120%', 'lg': '120%'},
      }
    },
    '& .cover-swatch-grid__tile-stock-message, & .cover-variant-tile-content-stock-message': {
      color: {base: 'greyscale.70', lg: 'greyscale.70'},
      fontSize: {base: '13px', lg: '12px'},
    },
    '& .cover-swatch-grid__tile-stock-message--in-stock, & .cover-variant-tile-content-stock-message--in-stock': {
      color: 'success.dark',
    },
    '& .cover-swatch-grid__tile-stock-message--low-stock, & .cover-variant-tile-content-stock-message--low-stock': {
      color: 'warning.dark',
    },
    '& .cover-swatch-grid__tile-stock-message--sold-out, & .cover-variant-tile-content-stock-message--sold-out': {
      color: 'error.standard',
    },
    // Cover "+N more" flyout (simple + complex PDP): hide "Included"; keep "+ $delta" / stock copy.
    '& .cover-swatch-overflow-flyout .cover-variant-tile-content-stock-message--included': {
      display: 'none',
    },
  },
  'body.page--product-page:has(#app-main.product-view--simple)': {
    '& .configuration-panel-header--gallery-detail': {
      paddingLeft: '24px',
      paddingRight: '24px',
    },
    '& .swiper-cf-011-thumbs': {
      '& .swiper-slide': {
        '& .rich-text-content .chakra-text': {
          fontSize: {base: '20px', lg: '24px'},
          fontWeight: 500,
          lineHeight: {'base': '150%', 'lg': '140%'},
        }
      }
    },
    '& .choose-your-layout-trigger-container': {
      borderBottomWidth: '2px',
    },
    '& .product-view__base-information-package:has(.product-view__short-description-skeleton)': {
      gap: {base: '16px', lg: '16px'},
    },
    '& #specifications': {
      '& .chakra-accordion__panel': {
        '& *': {
          fontSize: {base: '12px', lg: '16px'},
          fontWeight: 400,
          lineHeight: {'base': '120%', 'lg': '120%'},
        },
      },
      '& .product-support-accordion-content': {
        '& a': {
          fontSize: {base: '14px', lg: '16px'},
          fontWeight: 600,
          lineHeight: {'base': '120%', 'lg': '120%'},
        }
      },
    },
    '& .configuration-panel-header--gallery-layout ~ .gallery-overlay-content .view-details-container, & .gallery-panel:has(.configuration-panel-header--gallery-layout) .view-details-container': {
      paddingLeft: {base: '24px', lg: '0'},
      paddingRight: {base: '24px', lg: '0'},
    },

    '& .option-step-list__radio--simple-pdp, & .option-step-list__radio--simple-pdp-flyout': {
      backgroundColor: 'white',
      borderRadius: '4px',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      width: '100%',
    },
    '& .option-step-list__radio--simple-pdp .option-inner-radio-item, & .option-step-list__radio--simple-pdp-flyout .option-inner-radio-item': {
      alignItems: 'center',
      backgroundColor: 'white',
      border: 'none',
      borderBottom: '1px solid',
      borderColor: 'grayAlpha.10',
      borderRadius: 0,
      display: 'flex',
      gap: '16px',
      marginBottom: 0,
      width: '100%',
      _hover: {
        backgroundColor: 'gray.50',
        borderColor: 'grayAlpha.10',
      },
      '&:last-of-type': {
        borderBottom: 'none',
      },
    },
    '& .option-step-list__radio--simple-pdp .option-inner-radio-item': {
      padding: '16px',
    },
    '& .option-step-list__radio--simple-pdp-flyout .option-inner-radio-item': {
      padding: '16px 0',
    },
    '& .option-step-list__radio--simple-pdp .radio-option-content-container, & .option-step-list__radio--simple-pdp-flyout .radio-option-content-container': {
      gap: '16px',
      justifyContent: 'flex-start',
    },
    '& .option-step-list__radio--simple-pdp .radio-option-content-name-container, & .option-step-list__radio--simple-pdp-flyout .radio-option-content-name-container': {
      flex: 1,
      gap: '8px',
      maxWidth: 'none',
      minWidth: 0,
    },
    '& .option-step-list__radio--simple-pdp .radio-option-content-name1, & .option-step-list__radio--simple-pdp-flyout .radio-option-content-name1': {
      color: 'grayAlpha.90',
      fontFamily: 'body',
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 1.2,
    },
    '& .option-step-list__radio--simple-pdp .radio-option-content-name2, & .option-step-list__radio--simple-pdp-flyout .radio-option-content-name2': {
      color: 'grayAlpha.90',
      fontFamily: 'body',
      fontSize: '16px',
      fontStyle: 'normal',
      fontVariantNumeric: 'lining-nums proportional-nums',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    '& .option-step-list__radio--simple-pdp .radio-option-content-image, & .option-step-list__radio--simple-pdp-flyout .radio-option-content-image': {
      aspectRatio: '48/55',
      borderRadius: '4px',
      flexShrink: 0,
      height: '55px',
      maxHeight: '55px',
      maxWidth: '48px',
      minHeight: '55px',
      minWidth: '48px',
      objectFit: 'cover',
      overflow: 'hidden',
      width: '48px',
    },
    '& .option-step-list__radio--simple-pdp-flyout .radio-option-content-image--placeholder': {
      backgroundColor: '#D1D1D1',
      objectFit: 'unset',
    },
    /** Simple PDP slot cards (Choose/Change) — thumbnail 48×55 after selection, Figma-aligned with flyout picker. */
    '& .product-view--simple .customize-steps-slot-card .slot-card-image': {
      aspectRatio: '48/55',
      borderRadius: '4px',
      flexShrink: 0,
      height: '55px',
      maxHeight: '55px',
      maxWidth: '48px',
      minHeight: '55px',
      minWidth: '48px',
      objectFit: 'cover',
      overflow: 'hidden',
      width: '48px',
    },
    '& .product-view--simple .customize-steps-slot-card .slot-card-image--placeholder': {
      backgroundColor: '#D1D1D1',
      objectFit: 'unset',
    },
    '& .product-view--simple': {
      '& .cover-swatch-grid': {
        marginBottom: {base: '40px', lg: '48px'},
        '& .cover-swatch-grid__header': {
          marginBottom: {base: '16px', lg: '16px'},
        },
      },
      '& .cover-swatch-grid:has(+ .customize-steps-inline-content:empty),& .cover-swatch-grid:not(:has(+ .customize-steps-inline-content .customize-steps-content-body > *))': {
        marginBottom: {base: '40px', lg: '48px'},
      },
      '& .product-tabs-container +  .cover-swatch-grid': {
        marginTop: {base: '40px', lg: '48px'},
      },
      '& .optional-add-ons-container__root': {
        marginTop: {base: '0', lg: '0'},
      },
      '& .view-details-container': {
        marginLeft: {base: '0', lg: '0'},
        '&:has(.swiper-button-lock)': {
          marginLeft: {base: '0', lg: '-12px'},
        },
      },
      '& .review-section__stack:has(.configuration-thumbnail-swiper .swiper-button-lock) .view-details-thumbnail-swiper-container.view-details-column': {
        marginLeft: {lg: '0'},
      },
    },
    '& .cover-swatch-grid__description': {
      fontSize: {base: '13px', lg: '13px'},
      color: {base: 'gray.700', lg: 'gray.700'},
    },
    '& .customize-steps-inline-content': {
      paddingTop: {base: '56px', lg: '40px'},
      paddingBottom: {base: '40px', lg: '48px'},
      borderTop: '2px solid',
      borderColor: 'brandColors.greyscale10',
    },
    '& .choose-your-layout-trigger-container + .customize-steps-inline-content, & .configuration-selector-inner-container + .customize-steps-inline-content': {
      paddingTop: {base: '20px', lg: '0'},
      borderTop: {base: 'none', lg: 'none'},
    },
    '& .customize-steps-inline-content:empty, & .customize-steps-inline-content:not(:has(.customize-steps-content-body > *))': {
      display: 'none',
      paddingTop: {base: '0', lg: '0'},
      paddingBottom: {base: '0', lg: '0'},
    },
    '& .variations-section-content:not(:has(.choose-your-layout-trigger-container)) .product-tabs-container + *': {
      borderTop: 'none',
    },
    '& .variations-section-content:not(:has(.choose-your-layout-trigger-container)) .product-tabs-container + .customize-steps-inline-content': {
      paddingTop: {base: '40px', lg: '40px'},
    },
    '& .choose-your-layout-trigger-container + .pdp-delivery-availability': {
      borderTop: 'none',
      paddingTop: {base: '40px', lg: '40px'},
    },
    '& .variations-section-content:not(:has(.choose-your-layout-trigger-container)):not(:has(.optional-add-ons-container__root)):not(:has(.cover-swatch-grid)):not(:has(.choose-your-sets-container)):not(:has(.customize-steps-inline-content .customize-steps-content-body > *)) .pdp-delivery-availability': {
      borderTop: 'none',
      paddingTop: {base: '40px', lg: '40px'},
    },
    '& .cover-variant-tile-content': {
      gap: {base: '2px', lg: '2px'},
      '& .cover-variant-tile-content-stock-message, & .view-detail-link': {
        paddingTop: {base: '4px', lg: '4px'},
      },
    },
    '& .option-step-radio-container--simple-pdp': {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      '& .option-step-list__radio--simple-pdp': {
        order: 0,
      },
      '& .customize-steps-step-information': {
        padding: '0',
        order: 1,
        marginBottom: '0',
        '& .amb-markup .content': {
          color: 'greyscale.80',
          fontSize: '13px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '120%',
        }
      },
    },
    /** Simple PDP cushion step — Figma 7730:70341: 8px stack gap, separate option cards, 112×88 image. */
    '& .customize-steps-option-step--cushion.option-step-radio-container--simple-pdp': {
      gap: '8px',
      '& .option-step-list__radio--simple-pdp': {
        backgroundColor: 'transparent',
        borderRadius: 0,
        gap: '8px',
        overflow: 'visible',
      },
      '& .option-step-list__radio--simple-pdp .option-inner-radio-item': {
        border: '1px solid',
        borderColor: 'grayAlpha.10',
        borderRadius: '4px',
        marginBottom: 0,
        padding: '16px',
        '&:last-of-type': {
          borderBottom: '1px solid',
          borderColor: 'grayAlpha.10',
        },
        '&.option-inner-radio-item--selected': {
          border: '2px solid',
          borderColor: 'grayAlpha.90',
        },
      },
      '& .option-step-list__radio--simple-pdp .radio-option-content-image': {
        aspectRatio: '112 / 88',
        borderRadius: '6px',
        height: '88px',
        maxHeight: '88px',
        maxWidth: '112px',
        minHeight: '88px',
        minWidth: '112px',
        objectFit: 'contain',
        width: '112px',
      },
      '& .option-step-list__radio--simple-pdp .radio-option-content-name2': {
        color: 'grayAlpha.90',
        fontSize: {'base': '14px', lg: '16px'},
        fontWeight: 600,
        lineHeight: 1.4,
      },
      '& .option-step-list__radio--simple-pdp .radio-option-content-description': {
        color: '#7C7C7C',
        fontSize: {'base': '13px', lg: '12px'},
        fontWeight: 400,
        lineHeight: 1.2,
      },
    },
    '& .customize-steps-option-step-radio:has(.customize-steps-step-information .option-tooltip)': {
      gap: '0',
    },
    '& .customize-steps-step-information:has( .option-tooltip)': {
      backgroundColor: '#F1EDE4',
      border: '1px solid',
      borderRadius: '6px',
      borderColor: '#8C683B',
      order: 0,
      marginBottom: '8px',
      padding: '24px',
      '& .amb-markup > .content': {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        gridColumn: 1,
        minWidth: 0,
      },
      '& .amb-markup > *:not(.content)': {
        alignSelf: 'center',
        gridColumn: 2,
        gridRow: '1 / -1',
        justifySelf: 'end',
      },
      '& .amb-markup .content :is(h1, h2, h3, h4, h5, h6, p)': {
        margin: 0,
      },
      '& .amb-markup .content > :is(p:first-child, h1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child, h6:first-child)': {
        color: {base: 'black', lg: 'black'},
        fontFamily: 'body',
        fontSize: '14px',
        fontStyle: 'normal',
        fontVariantNumeric: 'lining-nums proportional-nums',
        fontWeight: {base: 600, lg: 600},
        lineHeight: '140%',
        '& strong, & b': {
          color: 'inherit',
          fontWeight: 'inherit',
        },
      },
      '& .amb-markup .content > p:nth-child(2):not(:has(.chakra-link))': {
        color: {base: 'brandColors.greyscale50', lg: 'brandColors.greyscale50'},
        fontFamily: 'body',
        fontSize: {base: '13px', lg: '13px'},
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '120%',
      },
      '& .option-tooltip': {
        alignItems: 'center',
        display: 'inline-flex',
        flexShrink: 0,
        height: '15px',
        justifyContent: 'center',
        minHeight: '15px',
        minWidth: '15px',
        width: '15px',
        '& svg': {
          height: '15px',
          width: '15px',
        },
      },
    },
    '& .swatch-option-card__label, & .cover-swatch-grid__tile-name-line1': {
      fontSize: {base: '13px', lg: '12px'},
      color: {base: '#000', lg: '#000'},
    },
    '& .cover-swatch-grid__tile-stock-message': {
      color: {base: 'greyscale.70', lg: 'greyscale.70'},
      paddingTop: {base: '4px', lg: '8px'},
    },
    '& .cover-swatch-grid__tile-stock-message--in-stock': {
      color: 'success.dark',
    },
    '& .cover-swatch-grid__tile-stock-message--low-stock': {
      color: 'warning.dark',
    },
    '& .cover-swatch-grid__tile-stock-message--sold-out': {
      color: 'error.standard',
    },
    '& .cover-variant-tile-content-stock-message': {
      color: {base: 'greyscale.70', lg: 'greyscale.70'},
    },
    '& .cover-variant-tile-content-stock-message--in-stock': {
      color: 'success.dark',
    },
    '& .cover-variant-tile-content-stock-message--low-stock': {
      color: 'warning.dark',
    },
    '& .cover-variant-tile-content-stock-message--sold-out': {
      color: 'error.standard',
    },
    '& .cover-swatch-grid__tile-view-details:has(+ .cover-swatch-grid__tile-stock-message)': {
      order: 4,
    },
    '& .cover-swatch-grid__tile-view-details': {
      paddingTop: {base: '4px', lg: '0'},
    },
    '& .variations-section-content-no-variant': {
      marginTop: {base: '16px', lg: '32px'},
      gap: {base: '0', lg: 4},
      '& .pdp-delivery-availability': {
        borderTop: {base: 'none', lg: '2px solid'},
        borderColor: {base: 'transparent', lg: 'grayAlpha.10'},
        paddingTop: {base: '0', lg: 16},
        marginBottom: {base: '8px', lg: '16px'},
      }
    },
    '& .product-view__main-flex-container-no-variant': {
      paddingBottom: {base: '40px', lg: '80px'},
      '& .product-view__base-information': {
        marginBottom: {base: '16px', lg: '0'},
      },
      '& .product-action-section': {
        paddingTop: {base: '40px', lg: '64px'},
      },
      '& .product-action-section-content .product-action-section-terms-and-conditions': {
        marginTop: {base: '40px', lg: '64px'},
      },
      '& + #specifications': {
        paddingTop: {base: '0', lg: '80px'},
      },
    },
  },
};
